import {
  Component,
  input,
  ChangeDetectionStrategy,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EMPTY, merge, switchMap } from 'rxjs';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ZOD_ERROR_KEY } from '@bossanova/models';

@Component({
  selector: 'bn-form-field-error',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
  template: `
    @if (
      control() &&
      control()?.touched &&
      control()?.errors?.[ZOD_ERROR_KEY]?.length > 0
    ) {
      @for (error of control()?.errors?.[ZOD_ERROR_KEY]; track $index) {
        <span class="error">{{ error.message }}</span>
      }
    }
  `,
  styleUrl: './form-field-error.component.scss',
})
export class FormFieldErrorComponent {
  control = input<AbstractControl | null>(null);
  protected readonly ZOD_ERROR_KEY = ZOD_ERROR_KEY;
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    toObservable(this.control)
      .pipe(
        switchMap(c => c ? merge(c.statusChanges, c.events) : EMPTY),
        takeUntilDestroyed()
      )
      .subscribe(() => this.cdr.markForCheck());
  }
}
